<template>
  <div>
    <K-Loading :Loading="Loading" v-if="!datas"></K-Loading>
    <div v-else>

      <section>
        <header>防伪查询</header>
        <div class="main-entName" v-text="datas.business.name"></div>
        <div class="logo"><img :src="datas.business.logo"></div>
        <div class="box">
          <div class="main-box">
            <div class="main-head"></div>
            <div class="main-datas">
              <div class="main-title">产品防伪查询：</div>
              <div class="main-search"><input v-model="vcode" @keyup.enter="CodeVerify" /></div>
              <div class="main-btn" @click="CodeVerify"><a>查 询</a></div>
              <ul class="main-txt">
                <li class="main-txt-title">防 伪 码 ：</li>
                <li class="main-txt-data" v-text="vcode"></li>
              </ul>
              <ul class="main-txt">
                <li class="main-txt-title">查询结果：</li>
                <li class="main-txt-data" v-text="hintTxt"></li>
              </ul>
            </div>
          </div>
        </div>

      </section>

    </div>
  </div>
</template>

<script>
let self, map;
import axios from 'axios'
import Swiper from 'swiper'
import Loading from '@/components/Loading.vue'
import Music from '@/components/Music.vue'
export default {
  name: 'AntiFake06',
  components: {
    'K-Loading': Loading,
    'K-Music': Music
  },
  data() {
    return {
      code: null,
      datas: null,
      msg: null,
      Loading: {
        type: 1,
        txt: "数据请求中..."
      },
      hintTxt: '',
      isShow: false,
      vcode: ''
    }
  },
  created() {
    self = this;
    document.querySelector('body').setAttribute('style', 'background-color:#FFF');

    //判断是演示还是真实码标
    if (this.$route.query.type == "demo") {
      self.GetDemoDatas(this.$route.query.pid, this.$route.query.rid);  //获取演示模板信息
    } else {
      self.code = self.GetCode();
      self.GetDatas();  //获取码标信息
    }
  },
  updated() {
    new Swiper('.banner', {
      autoplay: {
        delay: 5000
      },
      autoHeight: true, //高度随内容变化
    })
  },
  methods: {
    GetDemoDatas(pid, rid) {
      axios.get(self.GetServerUrl(1) + "template_product/" + pid + "/" + rid)
        .then(function (response) {
          let datas = response.data.meta;
          let defaultDatas = JSON.parse(datas.default_basic.config_value);  //初始化默认信息
          console.log(datas)
          if (datas.scan_count) {
            datas.scan_count = datas.scan_count;
          } else {
            datas.scan_count = 1;
          }
          datas.scan_first_time = "2017-10-31 12:12";
          datas.scan_first_address = "广东省深圳市";
          if (datas.focus) {
            datas.focus = JSON.parse(datas.focus);
          }
          if (datas.ref) {
            datas.ref = JSON.parse(datas.ref);
          } else {
            if (defaultDatas.ref) {
              datas.ref = JSON.parse(defaultDatas.ref);
            }
          }
          if (datas.menu) {
            datas.menu = JSON.parse(datas.menu);
          }
          if (datas.batch) {
            datas.batch = JSON.parse(datas.batch);
            datas.batch.qc = JSON.parse(datas.batch.qc);
          }
          if(datas.music && datas.music_is_show == 1){
            try {
              datas.music = JSON.parse(datas.music);
            } catch (error) {
              console.error(error)
            }
          }
          if (datas.video) {
            datas.video = JSON.parse(datas.video);
          }
          datas.activity_is_show = 1;

          //产品自定义属性
          if (datas.product.attribute) {
            datas.product.attribute = JSON.parse(datas.product.attribute);
          }

          //企业自定义属性
          if (datas.business.customize_data) {
            datas.business.customize_data = JSON.parse(datas.business.customize_data);
          }

          //默认信息
          if (!datas.process) {
            datas.process = defaultDatas.process;
          }
          if (!datas.process_demo) {
            datas.process_demo = defaultDatas.process_demo;
          }
          if (!datas.dealer) {
            datas.dealer = defaultDatas.dealer;
          }
          self.datas = datas;

          // document.title = self.datas.business.name;  //设置页面标题
        }).catch(function (error) {
          console.log(error)
          self.Loading.type = 3;
          self.Loading.txt = self.ErrorHint(error);
        })
    },
    GetDatas() {
      axios.get(self.GetServerUrl(1) + "query/" + self.code)
        .then(function (response) {

          let datas = response.data.meta.product_template;
          datas.scan_count = response.data.meta.scan_count;  //扫码次数
          datas.scan_first_time = response.data.meta.scan_first_time;  //扫码时间
          datas.scan_first_address = response.data.meta.scan_first_address;  //扫码地点
          if (response.data.meta.verify) {
            self.vcode = response.data.meta.verify;
            self.CodeVerify();
          }
          self.msg = "你所查询的是 " + datas.business.name + " 产品"
          if (datas.first_antifake_msg) {
            self.msg = datas.first_antifake_msg;
          }

          //针对某企业设置
          if (datas.scan_count > 1 && datas.business.rootid == "100010028") {
            datas.scan_count--
          }

          //产品自定义属性
          if (datas.product.attribute) {
            datas.product.attribute = JSON.parse(datas.product.attribute);
          }

          //企业自定义属性
          if (datas.business.customize_data) {
            datas.business.customize_data = JSON.parse(datas.business.customize_data);

            if (datas.business.customize_data) {
              for (let i in datas.business.customize_data) {
                if (datas.business.customize_data[i].key == "经纬度") {
                  self.location = datas.business.customize_data[i].value;
                }
              }
            }

          }
          //焦点图
          if (datas.focus) {
            datas.focus = JSON.parse(datas.focus);
          }
          //自定义栏目
          if (datas.ref) {
            datas.ref = JSON.parse(datas.ref);
          }
          //自定义菜单
          if (datas.menu) {
            datas.menu = JSON.parse(datas.menu);
          }
          //批次信息
          if (datas.batch) {
            if (datas.batch.qc) {
              datas.batch.qc = JSON.parse(datas.batch.qc);
            }
          }
          if(datas.music && datas.music_is_show == 1){
            try {
              datas.music = JSON.parse(datas.music);
            } catch (error) {
              console.error(error)
            }
          }
          if (datas.video) {
            datas.video = JSON.parse(datas.video);
          }
          datas.activity_is_show = 1;
          self.datas = datas;

          // document.title = self.datas.business.name;  //设置页面标题
        }).catch(function (error) {
          console.log(error)
          self.Loading.type = 3;
          self.Loading.txt = self.ErrorHint(error);
        })
    },
    CodeVerify() {
      axios.get(self.GetServerUrl(1) + "queryVerify/" + self.code + "/" + self.vcode)
        .then(function (response) {
          var json = response.data;
          if (json.code == 200) {
            self.hintTxt = `您好！您所查询的产品属于正品。您所查询的防伪码已被查询${json.meta.query_count}次，首次查询时间为：${json.meta.query_first_time} 如不是您亲自查询，谨防假冒！`
            if(json.meta.query_count === 1 && self.msg){
              self.hintTxt = self.msg;
            }
          } else {
            self.hintTxt = `防伪码不正确，谨防假冒！`
          }
        }).catch(function (error) {
          self.hintTxt = `防伪码不正确，谨防假冒！`
        })
    }
  }
}
</script>

<style scoped>
section {
  font-size: 16px;
}

* {
  padding: 0;
  margin: 0;
  list-style: none;
  outline: none !important;
  font-family: "微軟正黑體", sans-serif;
}

input,
select {
  border: 0;
  outline: none;
  border-radius: 0;
  appearance: button;
  -moz-appearance: button;
  /* Firefox */
  -webkit-appearance: button;
  /* Safari 和 Chrome */
}

header {
  color: #fff;
  padding: 15px;
  text-align: center;
  background-color: #d94d34;
}

.logo img {
  display: block;
  width: 55%;
  margin: 25px auto;
}

.box {
  padding: 0 30px 30px 30px;
}

.main-box {
  border-radius: 10px 10px 0 0;
  overflow: hidden;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.main-head {
  height: 20px;
  background-color: #d94d34;
}

.main-datas {
  padding: 20px;
}

.main-search {
  margin-top: 10px;
}

.main-search input {
  height: 40px;
  width: calc(100% - 20px);
  padding: 0 10px;
  font-size: 16px;
  border-radius: 5px;
  border: 1px solid #e9e9e9;
  box-shadow: 0 0px 4px rgba(0, 0, 0, 0.1) inset;
}

.main-btn {
  margin-bottom: 20px;
}

.main-btn a {
  color: #fff;
  display: block;
  padding: 15px 0;
  width: 180px;
  margin: 30px auto;
  text-align: center;
  border-radius: 5px;
  background-color: #d94d34;
}

.main-search-result {
  padding-top: 20px;
  border-top: 1px solid #E9E9E9;
}

.main-txt {
  overflow: hidden;
  margin-bottom: 5px;
  letter-spacing: 1px;
}

.main-txt li {
  float: left;
}

.main-txt-title {
  width: 100px;
}

.main-txt-data {
  width: calc(100% - 100px);
  color: #d94d34;
}

.main-entName {
  color: #d94d34;
  text-align: center;
  margin-top: 20px;
  font-size: 23px;
  font-weight: bold;
}

.main-search-result {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/view/AntiFake06.vue